import { Routes } from "akademika/akamont/constants/Routes";
import JSONModel from "sap/ui/model/json/JSONModel";
import { IsUserAdmin } from "../../services/AuthService";
import { FilterController } from "../sharedControllers/FilterController";

/**
 * @namespace akademika.akamont.pages.partnerList
 */
export default class PartnerList extends FilterController {
  route = Routes.PARTNER_LIST;
  parentRoute = Routes.DASHBOARD;

  public onInit() {
    super.onInit();
    const defaultFilters = {
      sapId: "",
      name: "",
      showDeleted: false,
    };

    this.initFilters(defaultFilters, 'api/Partner/GetPartnerList');
  }

  public onRouteMatched() {
    this.setModel(new JSONModel({ value: IsUserAdmin() }), 'isUserAdmin');
  }

  public onAddNewPartner() {
    this.navTo(Routes.PARTNER_ADD);
  }

  public onPartnerDetails(partnerId: number) {
    this.navTo(Routes.PARTNER_DETAILS, { id: partnerId });
  }
}
